import { MainGolfSearchFilter } from '@/pages/main/_components/golfSearch/mainGolfSearchFilter'
import { MainGolfSearchResult } from '@/pages/main/_components/golfSearch/mainGolfSearchResult'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'

export const MainGolfSearch = () => {
  const location = useLocation()
  const isSearchPage = location.pathname.includes('/detailSearch')
  return (
    <MainGolfSearchWrapper>
      {isSearchPage && <MainGolfSearchFilter />}
      <MainGolfSearchResult />
    </MainGolfSearchWrapper>
  )
}

const MainGolfSearchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  @media (max-width: 768px) {
    padding: 12px;
    gap: 16px;
  }  
`
